import getFacilityList from './facilityList';

const markedFacilityList = () => (
	getFacilityList(true)
);

export default markedFacilityList;



// WEBPACK FOOTER //
// ./src/js/request/markedFacilityList.js